import { render, staticRenderFns } from "./InstrumentNameCellToDetailPage.vue?vue&type=template&id=e2cf4996&scoped=true&"
import script from "./InstrumentNameCellToDetailPage.vue?vue&type=script&lang=js&"
export * from "./InstrumentNameCellToDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentNameCellToDetailPage.vue?vue&type=style&index=0&id=e2cf4996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cf4996",
  null
  
)

export default component.exports